import { AppAutenticacao } from "./components/autenticacao/AppAutenticacao";
import { AppDashboard } from "./components/dashboard/AppDashboard";
import AppOrcamento from "./components/orcamento/AppOrcamento";
import AppTarefa from "./components/tarefa/AppTarefa";
import AppUsuario from "./components/usuario/AppUsuario";
import { RouteDashboard, RouteLogin, RouteOrcamentos, RouteRoot, RouteTarefas, RouteUsuarios } from "./PathRoutes";

export const RoutesConfig = [
    {
        path:RouteRoot,
        component:(<AppAutenticacao/>),
        exact:true
    },
    {
        path:RouteDashboard,
        component:(<AppDashboard/>),
        exact:true
    },
    {
        path:RouteTarefas,
        component:(<AppTarefa/>),
        exact:true
    },
    {
        path:RouteOrcamentos,
        component:(<AppOrcamento/>),
        exact:true
    },    
    {
        path:RouteLogin,
        component:(<AppAutenticacao/>),
        exact:true
    },
    {
        path:RouteUsuarios,
        component:(<AppUsuario/>),
        exact:true
    },
];